import MuiLink from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { checkIfExternal } from '../../../utils/url-utils';

const PREFIX = 'ConditionalLink';

const classes = {
  link: `${PREFIX}-link`
};

const StyledLink = styled(Link)(({ theme }) => ({
  [`& .${classes.link}`]: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  }
}));

interface ConditionalLinkProps {
  children: ReactNode;
  link: string;
  tenantSymbol: string;
  enabled?: boolean;
  customClass?: string;
}

const ConditionalLink = ({
  enabled = true,
  link,
  tenantSymbol,
  children,
  customClass
}: ConditionalLinkProps) => {
  if (!link || !enabled) {
    return <>{children}</>;
  }

  if (checkIfExternal(link)) {
    return (
      <MuiLink
        target="_blank"
        color="inherit"
        href={link}
        underline="none"
        classes={{
          root: customClass
        }}
      >
        {children}
      </MuiLink>
    );
  }
  return (
    <StyledLink
      style={{ textDecorationLine: 'none' }}
      className={customClass || classes.link}
      to={`/${tenantSymbol}${link}`}
    >
      {children}
    </StyledLink>
  );
};

export default ConditionalLink;
